import gql from 'graphql-tag';
import { Fragments } from '@shared/api/fragments';

export const listBookmarks = gql`
  query ListBookmarksQuery($input: ListBookmarksInput) {
    listBookmarks(input: $input) {
      hasMore
      bookmarks {
        ...BookmarkListItem
      }
    }
  }

  ${Fragments.bookmark.bookmark}
`;
